import * as React from 'react';

import * as style from './index.css';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../utils/AdfoxContext';
import { AdFoxBanner } from '../AdfoxBanner';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'footerSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: '560px' };

export const SeoTopBanners: React.FC = () => {
  return (
    <div className={style['container']} data-name="SeoTopBanners">
      <AdfoxContextProvider size={SIZE} pParams={P_PARAMS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}>
        <AdFoxBanner />
      </AdfoxContextProvider>
    </div>
  );
};
